module.exports = __webpack_public_path__ + "img/logo-sm-light.99f2ebdd.png";